import { List, WhiteSpace } from 'antd-mobile'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getEcards, getProfile, getUserInfo } from '../../reducers/selectors'
import ProfileHeader from '../../components/MyProfile/ProfileHeader'

import { resetApp } from '../../actions'
import { FormattedMessage } from 'react-intl'

import BasicInfo from '../../components/MyProfile/BasicInfo'
import BindingYouzan from '../../components/MyProfile/BindingYouzan'
import OfficialQrCodeWrapper from '../../components/EcardsList/OfficialQrCodeWrapper'
import LanguageMenu from './LanguageMenu'
import BottomNav from '../../components/HomeNav/BottomNav'

import './MyProfile.css'
import { isMainlandUser } from '../../utils/user'
import { useHistory } from 'react-router-dom'
import MemberMenus from './MemberMenus'

function MyProfilePage() {
  const { push } = useHistory()
  const dispatch = useDispatch()
  const [showOfficalQrCode, setShowOfficalQrCode] = useState(false)
  const { userInfo, ecards, profiles } = useSelector((state) => ({
    ecards: getEcards(state),
    userInfo: getUserInfo(state),
    profiles: getProfile(state),
  }))

  if (!profiles || !userInfo) return null

  return (
    <div className="my-profile">
      <ProfileHeader wechat={profiles.wechat} ecards={ecards} />

      <BasicInfo userInfo={userInfo} storeInfo={profiles.storeInfo} />

      {showOfficalQrCode && (
        <OfficialQrCodeWrapper toogleShowOfficalQrCode={() => setShowOfficalQrCode(!showOfficalQrCode)} />
      )}

      <WhiteSpace size="sm" />
      <List className="profile-list">
        <List.Item arrow="horizontal" onClick={() => push('/my_purchases')}>
          <i className="fa fa-list-alt fa-lg fa-fw"></i>
          <FormattedMessage id="my-purchases" />
        </List.Item>
        <BindingYouzan pageEntry={'profile'}>
          <List.Item arrow="horizontal" platform="cross">
            <i className="fa fa-vcard-o fa-lg fa-fw"></i>
            <FormattedMessage id="profile-youzan" />
          </List.Item>
        </BindingYouzan>
        {!profiles.storeInfo && isMainlandUser(userInfo) && (
          <>
            <List.Item arrow="horizontal" onClick={() => push('/cart')}>
              <i className="fa fa-vcard-o fa-lg fa-fw"></i>
              <FormattedMessage id="cardRequest" />
            </List.Item>
            <List.Item arrow="horizontal" onClick={() => push('/public_welfare_cert')}>
              <i className="fa fa-diamond fa-lg fa-fw"></i>
              我的公益证书
            </List.Item>
          </>
        )}
        <List.Item arrow="horizontal" onClick={() => push('/pro_check')}>
          <i className="fa fa-check-circle-o fa-lg fa-fw"></i>
          <FormattedMessage id="procheck" />
        </List.Item>
      </List>
      <WhiteSpace size="sm" />

      {/**
       * Member Zone
       */}
      <MemberMenus profiles={profiles} />

      {/**
       * Language and Copyright
       */}
      <List className="profile-list">
        <LanguageMenu />
        <List.Item
          arrow="horizontal"
          onClick={() => {
            dispatch(resetApp())
            push('/emailLogin')
          }}
        >
          <i className="fa fa-envelope-o fa-lg fa-fw"></i>
          <FormattedMessage id="profile-email" />
        </List.Item>
        <List.Item arrow="horizontal" onClick={() => push('/user_agreements')}>
          <i className="fa fa-file-text-o fa-lg fa-fw"></i>
          隐私与用户协议
        </List.Item>
        <List.Item arrow="horizontal" onClick={() => setShowOfficalQrCode(!showOfficalQrCode)}>
          <i className="fa fa-copyright fa-lg fa-fw"></i>
          <FormattedMessage id="profile-copyright" />
        </List.Item>
      </List>
      <WhiteSpace size="sm" />
      <div style={{ width: '100%', height: '60px' }}></div>
      <BottomNav isMainlandUser={isMainlandUser(userInfo)} />
    </div>
  )
}

export default MyProfilePage
